import {React,useState} from "react";
// import InternshipSection from "../../dashboard/InternshipSection";
import { Box, Grid } from "@mui/material";
// import TotalSection from "./TotalSection";
// import TicketSection from "./TicketSection";
// import InstituteSection from "./InstituteSection";
import Status from "./Status";
import SatffElegantCarousel from "./SatffElegantCarousel";


const StaffDashboard = () => {

  const [showCarousel, setShowCarousel] = useState(true);

  // Define the close function
  const handleCloseCarousel = () => {
    setShowCarousel(false);
    // Add any other cleanup logic here if needed
  };

  return (
    <Box sx={{ my: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Status />
        </Grid>
        {/* <Grid item xs={12} md={3}>
          <TotalSection />
        </Grid> */}
        <Grid item xs={12} md={9}>
          <Grid container spacing={2}>
            {/* <Grid item xs={12} sm={7}>
              <TicketSection />
            </Grid>
            <Grid item xs={12} sm={5}>
              <InstituteSection />
            </Grid> */}
        
            {/* <SatffElegantCarousel /> */}
            
            {/* <SatffElegantCarousel onClose={handleCloseCarousel} /> */}
                 {showCarousel && (
        <SatffElegantCarousel onClose={handleCloseCarousel} />
      )}

          </Grid>
        </Grid>
      </Grid>
      <Box my={2}>{/* <InternshipSection /> */}</Box>
    </Box>
  );
};

export default StaffDashboard;
